module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-stone-path-background.53828337.png";